<template>
  <div style="height:100%;">
    <div v-wechat-title="($route.meta.title = docTitle)"></div>
    <!-- 搜索组件 -->
    <searchBar @search="openSearch = true" :placeholder="'公司名称/展馆/类别'" :theme="1"></searchBar>

    <div class="yd-content head ">
      <van-tabs v-model="activeName" @click="changeTab" class="head_nav">
        <van-tab title="资讯头条" name="news" v-if="enabledArticle">
          <news v-if="activeName == 'news'"></news>
        </van-tab>
        <van-tab title="供需商机" name="needs">
          <needs v-if="activeName == 'needs'"></needs>
        </van-tab>
        <van-tab title="行业人脉" name="connect">
          <connect v-if="activeName == 'connect'"></connect>
        </van-tab>
        <van-tab title="图片直播" name="live">
          <live v-if="activeName == 'live'"></live>
        </van-tab>

        <van-tab title="热点话题" name="hot">
          <hot v-if="activeName == 'hot'"></hot>
        </van-tab>
        <van-tab title="展会概况" name="exinfo">
          <exinfo v-if="activeName == 'exinfo'"></exinfo>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 热门搜索 -->
    <searchPage :show="openSearch" :placeholder="placeholder" :type="rankingType" @callback="setSearch" ref="search"></searchPage>

    <layoutFooter></layoutFooter>

    <leftTool :curIndex="activeName" v-if="activeName" @toolHandle="toolHandle"></leftTool>
  </div>
</template>

<script>
import searchBar from "@/components/searchBar/index"; // 搜索切换
import searchPage from "@/components/searchPage"; // 搜索页
import layoutFooter from "@components/layout-footer";
import leftTool from "./component/left-tool.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "headlines",
  data () {
    return {
      openSearch: false, // 控制搜索组件
      headTab: [
        { name: "资讯头条", type: "news", url: "/news" },
        { name: "供需商机", type: "needs", url: "/headlinesNeeds" },
        { name: "行业人脉", type: "connect", url: "/headlinesConnect" },
        { name: "图片直播", type: "live", url: "/headlinesLive" },
        { name: "热点话题", type: "hot", url: "/headlinesHot" },
        { name: "展会概况", type: "exinfo", url: "/headlinesExinfo" },
      ],
      componentType: "exinfo",
      activeName: "",
      exhibitionId: "",
      docTitle: "Overview",
      // 搜索框data
      rankingType: "CompInfo", // 默认显示展商
      searchType: 0, // 搜索类型
      placeholder: "公司名称/展馆/类别",
      // 搜索框data
      shareV: {
        content: "",
        poster: "",
      },
    };
  },
  components: {
    searchBar,
    searchPage,
    layoutFooter,
    leftTool,
    news: () => import("./component/news.vue"), // 资讯
    needs: () => import("./component/needs2.vue"), // 商机
    connect: () => import("./component/connections.vue"), // 行业人脉
    live: () => import("./component/live.vue"), // 图文直播
    hot: () => import("./component/hot.vue"), // 热点
    exinfo: () => import("./component/exinfo.vue"), // 概况
  },
  computed: {
    ...mapGetters({
      activeTab: "getHeadTab",
      exhibitionInfo: "getExhibitionInfo",
      exhibitionConfig: "getExhibitionConfig",
      userInfo: "getUserInfo",
    }),
    query () {
      return this.$router.history.current.query;
    },
    enabledArticle () {
      return this.exhibitionConfig && this.exhibitionConfig.feature && this.exhibitionConfig.feature.enabledArticle;
    },
  },
  created () {
    this.init();
    this.activeName = "exinfo";
    this.headTab.forEach((c) => {
      if (c.type == this.activeName) {
        this.docTitle = this.exhibitionInfo.exhibition.name + "-" + c.name;
      }
    });
    console.log("query", this.query);
  },
  methods: {
    ...mapActions({
      LinkHotPub: "linkTo/LinkHotPub",
      LinkHotSupply: "linkTo/LinkHotSupply",
      shareToWechat: "wxShare/shareToWechat",
      getSettingShare: "wxShare/getSettingShare", //分享配置展会
      LinkToHeadLinesTab: "linkTo/LinkToHeadLinesTab", //去头条其他页
    }),
    async init () {
      this.exhibitionId = this.$route.params.id;
      this.$store.commit("setExhibitionId", this.exhibitionId);
      await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId, this.userId);
      if (localStorage.getItem("relepase")) {
        localStorage.setItem("relepase", "");
      }
      if (localStorage.getItem("Upimg")) {
        localStorage.setItem("Upimg", "");
      }
      if (localStorage.getItem("content")) {
        localStorage.setItem("content", "");
      }
      // 分享的配置
      await this.getShareVal();
      const opt = {
        title: this.shareV.content ? this.shareV.content : "诚邀您参观 " + this.exhibitionInfo.exhibition.name + " 线上展",
        desc: this.shareV.des || this.exhibitionInfo.exhibition.remark,
        link: window.location.href,
        imgUrl: this.exhibitionInfo.exhibition.logo,
      };
      this.shareToWechat(opt);
    },
    // 获取展会的分享配置
    async getShareVal () {
      let res = await this.getSettingShare({ id: this.exhibitionId, name: "share.exhibition.config" });
      if (res) {
        this.shareV = JSON.parse(res);
      }
    },
    changeTab (type, name) {
      console.log(type, name, url, "hahha");
      this.headTab.forEach((c) => {
        if (c.type == this.activeName) {
          this.LinkToHeadLinesTab(c.url);
        }
      });
      this.docTitle = this.exhibitionInfo.exhibition.name + "-" + name;
      console.log(this.docTitle, "this.docTitle");
    },
    toolHandle (type) {
      if (type == "talk") {
        // 免费资讯
      }
      if (type == "fb") {
        // 发布商机
        if (!this.userInfo.phone) {
          this.$Myapollo.unverifiedDialog(this);
          return;
        }
        this.LinkHotSupply();
      }
      if (type == "public") {
        // 发布话题
        if (!this.userInfo.phone) {
          this.$Myapollo.unverifiedDialog(this);
          return;
        }
        this.LinkHotPub({ id: false, talkId: false });
      }
    },
    setSearch (e) {
      // 设置搜索值
      console.log(e, "设置搜索值");
      this.openSearch = false;
      this.searchText = e.txt;
      this.searchType = e.type; // 0为输入搜索，1为展馆，2为类别
      this.$store.commit("setSearch", this.searchText);
      if (this.searchText) {
        this.$router.push(`/exhibition/${this.exhibitionId}?search=${this.searchText}&searchType=${this.searchType}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.yd-content {
  padding-bottom: 50px;
  padding-top: 0.93rem;
  background: #f5f5f5;
  min-height: 100vh;
}
::v-deep .head {
  &-tab {
    display: flex;
    height: 0.88rem;
    align-items: center;
    justify-content: space-around;
    background: #fff;
    padding: 0 5%;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1.6rem;
      height: 0.48rem;
      color: #333;
      font-size: 0.26rem;
      // line-height: 24px;
      text-align: center;
    }
    .active {
      background-color: #1890ff;
      border-radius: 0.24rem;
      color: #fff;
      width: 1.6rem;
    }
  }
  .head_nav {
    .van-tabs__wrap {
      position: fixed;
      top: 0.93rem;
      left: 0;
      right: 0;
      .van-tabs__nav {
        .van-tab {
          .van-tab__text {
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: initial;
          }
        }
      }
    }
  }
}
</style>
